export default {
  GET_RELATIONSHIPS_QUERY_SERVICE: Symbol.for('GET_RELATIONSHIPS_QUERY_SERVICE'),
  RELATIONSHIP_REPOSITORY: Symbol.for('RELATIONSHIP_REPOSITORY'),
  ONBOARDING_CATALOGS_RELATIONSHIP_STATE_MANAGER:
    Symbol.for('ONBOARDING_CATALOGS_RELATIONSHIP_STATE_MANAGER'),
};
